/**
 * @description A list of supported cities (they can be treated as city ids)
 * where we provide services.
 *  - They are lowercase due to easier/saner fuse.js search implementation
 *  - Use function `getSupportedCitites` if you want to use the city list
 *  in a form. The function will append a production test city for admins.
 */
export const SUPPORTED_CITIES_B2B = [
  // B2B cities (23 cities) - available for admin/partner reservations
  // Includes all B2C cities plus B2B-only cities
  { name: 'bari', lng: 16.7931622, lat: 41.1139023 },
  { name: 'bergamo', lng: 9.668711, lat: 45.6941984 },
  { name: 'bologna', lng: 11.3426, lat: 44.4932318 },
  { name: 'brescia', lng: 10.2156823, lat: 45.5403137 },
  { name: 'cagliari', lng: 9.0871787, lat: 39.2253971 },
  { name: 'catania', lng: 15.0850115, lat: 37.5023308 },
  { name: 'firenze', lng: 11.2463453, lat: 43.7751269 },
  { name: 'genova', lng: 8.9097227, lat: 44.4083582 },
  { name: 'legnano', lng: 8.8934839, lat: 45.5931132 },
  { name: 'milano', lng: 9.18854, lat: 45.464664 },
  { name: 'monza', lng: 9.2735078, lat: 45.583547 },
  { name: 'napoli', lng: 14.2681, lat: 40.8518 },
  { name: 'novara', lng: 8.5951815, lat: 45.4538271 },
  { name: 'padova', lng: 11.8713873, lat: 45.4089257 },
  { name: 'palermo', lng: 13.3548028, lat: 38.1142286 },
  { name: 'perugia', lng: 12.374487, lat: 43.106041 },
  { name: 'pescara', lng: 14.2160, lat: 42.4618 },
  { name: 'pisa', lng: 10.4018624, lat: 43.7159395 },
  { name: 'reggiocalabria', lng: 15.66129, lat: 38.11047 },
  { name: 'roma', lng: 12.4841008, lat: 41.8962146 },
  { name: 'salerno', lng: 14.7933, lat: 40.6755 },
  { name: 'torino', lng: 7.6778283, lat: 45.0712738 },
  { name: 'vicenza', lng: 11.55, lat: 45.549999 },
  { name: 'PRODUCTION_TEST_CITY', lng: 9.18854, lat: 45.464664 },
];

/**
 * @description returns a PRODUCTION_TEST_CITY if the user is an admin
 */
export const getSupportedB2BCities = (isAdmin: boolean) => {
  const cities = SUPPORTED_CITIES_B2B.map((c) => c.name);

  if (!isAdmin) {
    cities.splice(cities.indexOf('PRODUCTION_TEST_CITY'), 1);
  }

  return cities;
};
